import { Chip, Grid, Typography } from '@mui/material'
import { HIGH_RISK, LOW_RISK, MEDIUM_RISK } from 'pgsse/constant/PgsseConstants'
import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { CardTable } from 'components/datatable/NewTable'


const LabelRisk = ({
    risk = {},
}) => {
    return (
        <Grid
            container
            gap={2}
            py={1}
            alignItems={'center'}
        >
            <Chip
                sx={{
                    height: 25,
                    width: 6,
                    backgroundColor: risk.color,
                }}
            />
            <Typography> {i18n[risk.name]} </Typography>
        </Grid>
    )
}

LabelRisk.propTypes = {
    risk: PropTypes.shape({
        name: PropTypes.string,
        color: PropTypes.string,
    }),
}

const StatsTable = ({
    riskValues = {},
}) => {
    const headers = [{ key: 'severity', value: i18n.riskSeverity }, { key: 'quantity', value: i18n.riskNb }]

    const formattedRisk = [
        {
            severity: <LabelRisk risk={HIGH_RISK}/>,
            quantity: riskValues.high,
        },
        {
            severity: <LabelRisk risk={MEDIUM_RISK}/>,
            quantity: riskValues.medium,
        },
        {
            severity: <LabelRisk risk={LOW_RISK}/>,
            quantity: riskValues.low,
        },
    ]

    return (
        <CardTable
            title={i18n.statistics}
            headers={headers}
            rows={formattedRisk}
        />
    )
}

StatsTable.propTypes = {
    riskValues: PropTypes.shape({
        high: PropTypes.string,
        medium: PropTypes.string,
        low: PropTypes.string,
    }),
}

export default StatsTable
